import { render, staticRenderFns } from "./storage-period-recommendation.vue?vue&type=template&id=3498e8b4"
import script from "./storage-period-recommendation.vue?vue&type=script&lang=js"
export * from "./storage-period-recommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports